import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import ko from './ko';
import en from './en';

const saved = localStorage.getItem('pure-seoul-lang');

i18n
  .use(initReactI18next)
  .init({
    resources: {
      ko: { translation: ko },
      en: { translation: en },
    },
    lng: saved === 'ko' ? 'ko' : 'en',
    fallbackLng: 'en',
    interpolation: { escapeValue: false },
  });

export default i18n;
